import { gql } from '@apollo/client';

const INIT_SITE_NEWS_ASSET_UPLOAD = gql`
  mutation initSiteNewsAssetUpload($siteId: Int!) {
    initSiteNewsAssetUpload(siteId: $siteId)
  }
`;

export default INIT_SITE_NEWS_ASSET_UPLOAD;
